import { useEffect, useMemo, useState } from 'react'
import { Slider as S, Col, Row, Modal } from 'antd'
import styled from 'styled-components'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import { formatWithTimezone, getDateV2 } from 'src/libs/util'
import format from 'date-fns/format'
import { useTranslation } from 'react-i18next'
import useGetWithContext, { useGetDataFromStore } from 'src/hooks/useGetWithContext'
import { useGetCategories } from 'src/hooks/useGetCategoriesV2'
import { CATEGORY_TYPE } from 'src/libs/constant'
import { additionalZero, timeConvertHHmm } from 'src/libs/date'
import videoConfferenceApi from 'src/api/videoConferenceApi'
import { isArray, uniqBy, isNaN } from 'lodash'
import userApi from 'src/api/userApi'
// import TrackingTime from './TimeProgress'

export const Slider = styled(S)`
  &.ant-slider-disabled .ant-slider-track {
    background-color: #91d5ff !important;
  }
  &.ant-slider-disabled .ant-slider-handle,
  .ant-slider-disabled .ant-slider-dot {
    background-color: #91d5ff;
    border-color: #8cc8ff !important;
  }
`

const STUDENT = 'STUDENT'
const TEACHER = 'TEACHER'

/**
 *
 * @param {Object} props
 * @param {Object} props.session - Thông tin buổi học, lấy từ API backend trả về
 * @param {Boolean} props.visible - Cờ hiển thị modal
 * @param {Function} props.onClose - Action đóng modal
 * @returns
 */
export default function ModalTimeSessionTrack ({ session, visible, onClose }) {
  const { t } = useTranslation()
  // const { getCategoryData: getTimeSlot } = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)
  // const timeSlot = useMemo(() => getTimeSlot(session?.classTimeSlotId), [session?.classTimeSlotId])
  // const { data: recordDetail } = useGetWithContext(`GET_RECORD_SESSION_${session?.code}`, videoConfferenceApi.getSessionRecordDetail, session?.code, { isDisabled: !session?.code })
  // const recordTimes = useMemo(() => {
  //   if (!recordDetail) return []
  //   const { studentAccountDetails, teacherAccountDetail, classInData } = recordDetail
  //   let dataOutput = []
  //   const classInTeacherId = teacherAccountDetail?.partnerIds?.find(item => item.partner === 'CLASS_IN')?.id
  //   if (classInTeacherId) {
  //     const classInDataDetail = classInData?.inOutData?.[classInTeacherId]
  //     dataOutput.push({
  //       role: 'TEACHER',
  //       personId: teacherAccountDetail.userClientId,
  //       timeInSessions: classInDataDetail?.Details || [],
  //       total: classInDataDetail?.Total
  //     })
  //   }
  //   dataOutput = dataOutput.concat(studentAccountDetails?.map(itemStudent => {
  //     const classInStudentId = itemStudent?.partnerIds?.find(item => item.partner === 'CLASS_IN')?.id
  //     if (classInStudentId) {
  //       const classInDataDetail = classInData?.inOutData?.[classInStudentId]
  //       return {
  //         role: 'STUDENT',
  //         personId: itemStudent.userClientId,
  //         timeInSessions: classInDataDetail?.Details || [],
  //         total: classInDataDetail?.Total
  //       }
  //     }
  //   }) || [])
  //   return dataOutput?.filter(item => !!item)
  // }, [recordDetail])
  return (
    <Modal visible={visible} onCancel={onClose} footer={null} title={t('page.class.text.learning_time')} style={{ minWidth: '60%' }}>
      {/* {!!session && (<TrackingTime classStartTime={timeSlot?.startTime} classEndTime={timeSlot?.endTime} timeTracking={recordTimes} />)} */}
      {!!session && (<TimeProgress session={session} />)}
    </Modal>
  )
}

/**
 * Convert object time lấy từ API backend trả về
 * @param {Object} time - Object time tracking trong lớp lấy từ API backend trả về
 * @param {Number} time.date - Ngày học có dạng YYYYmmdd. VD: 20221225 (25/12/2022)
 * @param {Number} time.hour - Giờ học. VD: 9 (9 giờ)
 * @param {Number} time.minute - Phút học. VD: 30 (30 phút)
 * @returns {Object} - Trả về Object Date
 */
function getDateByTime (time) {
  return getDateV2(String(time.date), `${additionalZero(time.hour)}:${additionalZero(time.minute)}`)
}

/**
 * Lọc học sinh đang học trong lớp
 * @param {Array} students - Lấy từ API backend trả về (*api/calendar/task/arrange-class/id-with-children)
 * @returns {Array}
 */
function getStudentsInClass (students) {
  if (!students || !students.length) return []
  return students.filter(student => student.status !== 'REMOVED_STUDENT')
}

function greaterThan (value, compareValue) {
  return Boolean(value > compareValue)
}

function lessThan (value, compareValue) {
  return Boolean(value < compareValue)
}

/** *
 * @param {Array} userInOutLogs
 * @param {String} userInOutLogs[].Type
 * @param {Number} userInOutLogs[].Time - timestamp log
 * @param {Number} defaultUserLogTime - timestamp log
 * @returns {Number}
 */
function getUserLogTime (logType, userInOutLogs, defaultUserLogTime) {
  let userLogTime = 0
  let userLogType = ''
  let operatorCompare

  switch (logType) {
    case 'FIRST':
      userLogType = 'In'
      operatorCompare = lessThan
      break
    case 'LAST':
      userLogType = 'Out'
      operatorCompare = greaterThan
      break
  }

  if (!userLogType) return 0

  if (isArray(userInOutLogs) && userInOutLogs.length) {
    const userLogs = userInOutLogs.filter(log => log.Type === userLogType)
    userLogs.forEach((log) => {
      if (!userLogTime || operatorCompare(log.Time, userLogTime)) userLogTime = log.Time
    })
  }
  if (!userLogTime && defaultUserLogTime) {
    const defaultLogTime = Number(defaultUserLogTime)
    if (!isNaN(defaultLogTime)) userLogTime = defaultLogTime
  }
  return userLogTime
}

// function getInOutDataRealTeacher(inOutData) {
//   if (!inOutData || !isObject(inOutData)) return null

//   const classInUserIds = Object.keys(inOutData)

//   if (!classInUserIds.length) return null
//   if (classInUserIds.length === 1) return inOutData[classInUserIds[0]]   
  
//   let logInOutOfRealTeacher = null
//   for (let i = 0; i < classInUserIds.length; i++) {
//     const classInUserId = classInUserIds[i]
//     const logInOut = inOutData[classInUserId]
//     if (logInOut?.Identity != '3') continue    
//     if (!logInOutOfRealTeacher) {
//       logInOutOfRealTeacher = logInOut
//       continue
//     }
//     if (logInOut.Total > logInOutOfRealTeacher.Total) {
//       logInOutOfRealTeacher = logInOut
//     }
//   }
//   return logInOutOfRealTeacher
// }

// function getInOutDataOfTeachers(inOutData) {
//   if (!inOutData || !isObject(inOutData)) return null

//   return  Object.keys(inOutData || {}).reduce((logOfTeachers, classInUserId) => {
//     const logInOut = inOutData[classInUserId]
//     if (logInOut.Identity === '3') {
//       return {
//         ...logOfTeachers,
//         [classInUserId]: logInOut
//       }
//     }
//     return logOfTeachers
//   }, {})
// }

/**
 *
 * @param {Object} props
 * @param {Object} props.session - Thông tin buổi học, lấy từ API backend trả về
 * @returns
 */
const TimeProgress = ({ session }) => {
  const { t } = useTranslation()
  const { getCategoryData: getTimeSlot } = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)

  const { getDataFromStore } = useGetDataFromStore() // to get data from studentInfo component

  const { learnDate, classTimeSlotId, teacherId, studentIds, students, mgmtClassInAcctId } = session
  const timeSlot = useMemo(() => getTimeSlot(classTimeSlotId), [classTimeSlotId])

  const { data: recordDetail } = useGetWithContext(`GET_RECORD_SESSION_${session?.code}`, videoConfferenceApi.getSessionRecordDetail, session?.code, { isDisabled: !session?.code })

  const recordTimes = useMemo(() => {
    let startClassTime = getDateV2(String(learnDate), timeConvertHHmm(timeSlot?.startTime))
    let endClassTime = getDateV2(String(learnDate), timeConvertHHmm(timeSlot?.endTime))
    let listUsersInClass = uniqBy([
      ...(teacherId ? [{ role: TEACHER, id: `${teacherId}`, userClientId: mgmtClassInAcctId }] : []),
      ...(studentIds || []).map(studentId => ({ role: STUDENT, id: `${studentId}`, userClientId: studentId })),
      ...(getStudentsInClass(students)?.map(student => ({ role: STUDENT, id: `${student.studentId}`, userClientId: student.studentId })) || [])
    ], 'id')
    let recordUsersInClass = []

    if (recordDetail) {
      // Ghi đè thời gian bắt đầu và kết thúc buổi học thực tế
      const { beginTime, endTime, teacherAccountDetail, studentAccountDetails } = recordDetail
      recordUsersInClass = [
        ...(teacherAccountDetail ? [{ role: TEACHER, ...teacherAccountDetail }] : []),
        ...((studentAccountDetails?.map((student) => ({ role: STUDENT, ...student }))) || [])
      ]
      if (beginTime) startClassTime = getDateByTime(beginTime)
      if (endTime) endClassTime = getDateByTime(endTime)
      // Ghi đè danh sách user thực tế có trong lớp học
      // listUsersInClass = intersectionBy(listUsersInClass, recordUsersInClass.map(user => ({ role: user.role, id: `${user.userClientId}` })), 'id')
      // const recordTeacherDetailHasInListUsers = Boolean(listUsersInClass.find(user => user.id === `${teacherAccountDetail.userClientId}`))
      // if (!recordTeacherDetailHasInListUsers) {
      //   listUsersInClass = [{ role: TEACHER, id: `${teacherAccountDetail.userClientId}` }].concat(listUsersInClass)
      // }
    }
    // Thời lượng buổi học, theo đơn vị phút. VD 45 phút
    const duration = Math.floor((endClassTime - startClassTime) / 60000)
    // Giờ giấc học. VD: 9:00
    const startTimeStr = format(startClassTime, 'HH:mm')
    const endTimeStr = format(endClassTime, 'HH:mm')

    // Tạo object tracking cho khung thời gian học của lớp
    const defaultMarks = {
      0: {
        label: startTimeStr
      },
      [duration]: {
        label: endTimeStr
      }
    }
    // Tạo object tracking cho khoảng thời gian online của user trong lớp (gồm cả giáo viên, học sinh...)
    const list = listUsersInClass.reduce((acc, user) => {
      if (user.id) {
        const userType =
              user.role === TEACHER
                ? t('page.class.label.teacher')
                : t('page.class.label.student')
        const classInUser = recordUsersInClass.find(recordUser => recordUser.userClientId == user.userClientId)
        let classInUserId = classInUser?.partnerIds?.find(u => u.partner === 'CLASS_IN')?.id || ''

        if (!classInUserId && user.id == teacherId) {
          /**
           * Case giáo viên thực tế ko phải GVCN.
           */
          classInUserId = recordDetail?.classInData?.actualTeacherId || ''        
          
          // const logInOutTeachers = getInOutDataOfTeachers(recordDetail?.classInData?.inOutData)
          // const teacherAccountDetail = recordUsersInClass[0]?.role === TEACHER ? recordUsersInClass[0]: null
          // const teacherClassInId = teacherAccountDetail?.partnerIds?.find(u => u.partner === 'CLASS_IN')?.id
          // if (teacherAccountDetail && teacherClassInId) delete logInOutTeachers[teacherClassInId]
          // userInOutLog = getInOutDataRealTeacher(logInOutTeachers)?.Details
        }
        const userInOutLog = classInUserId ? recordDetail?.classInData?.inOutData?.[classInUserId]?.Details : []
        const userFirstLoginOldVersionLog = classInUserId ? recordDetail?.classInData?.firstLoginAt?.[classInUserId] : 0
        const userLastLogoutOldVersionLog = classInUserId ? recordDetail?.classInData?.lastLogoutAt?.[classInUserId] : 0

        const firstLoginAt = getUserLogTime('FIRST', userInOutLog, userFirstLoginOldVersionLog)
        const lastLogoutAt = getUserLogTime('LAST', userInOutLog, userLastLogoutOldVersionLog)

        let userDetail = getDataFromStore(`GET_USER_BY_ID_${user.id}`)
        if (!userDetail) userDetail = getDataFromStore(`GET_STUDENT_DETAIL_BY_${user.id}`) || {}

        const marks = {}

        if (firstLoginAt) {
          const firstLogin = new Date(firstLoginAt * 1000)
          let start = differenceInMinutes(firstLogin, startClassTime)
          if (start < 0) start = 0
          marks[start] = start === 0 ? startTimeStr : formatWithTimezone(firstLogin, 'HH:mm')
        }

        if (lastLogoutAt) {
          const lastLogout = new Date(lastLogoutAt * 1000)
          let end = differenceInMinutes(lastLogout, startClassTime)
          if (end < 0) {
            end = 0
            marks[end] = startTimeStr
          } else if (end > duration) {
            end = duration
            marks[end] = endTimeStr
          } else {
            marks[end] = formatWithTimezone(lastLogout, 'HH:mm')
          }
        }

        acc = acc.concat({
          title: `${userType}: ${userDetail.userName || t('page.class.text.no_name')}`,
          user: {
            username: userDetail.userName,
            ...user
          },
          marks,
          key: user.id
        })
      }
      return acc
    }, [{
      key: `${startTimeStr}|${endTimeStr}`,
      marks: defaultMarks,
      title: t('page.class.text.learning_assigned_time')
    }])

    return {
      defaultMarks,
      duration,
      list
    }
  }, [recordDetail])

  if (recordTimes) {
    return (
      <>
        {recordTimes.list?.map((item) => {
          return (
            <TimeSlider
              key={`tracking-time-${item.key}`}
              marks={item.marks}
              title={item.title}
              user={item.user}
              duration={recordTimes.duration}
              defaultMarks={recordTimes.defaultMarks}
            />
          )
        })}
      </>
    )
  }
  return null
}

function TimeSlider ({ duration, marks, title, user, defaultMarks }) {
  const { t } = useTranslation()
  const [sliderMarks, setSliderMarks] = useState()
  const [sliderTitle, setSliderTitle] = useState('')

  const defaultValue = useMemo(() => {
    return Object.keys(marks).map((key) => Number(key))
  }, [marks])

  const isStudent = user?.role === STUDENT
  const userId = user?.id

  const { data: userDetail } = useGetWithContext(
    isStudent ? `GET_STUDENT_DETAIL_BY_${userId}` : `GET_USER_BY_ID_${userId}`,
    isStudent ? userApi.detailStudent : userApi.detail,
    userId,
    { isDisabled: user?.username || !userId },
    [userId]
  )

  useEffect(() => {
    setSliderTitle(userDetail ? title.replace(t('page.class.text.no_name'), userDetail.userName) : '')
  }, [userDetail])

  useEffect(() => {
    setSliderMarks(null)
    let _sliderMarks
    if (!Object.keys(marks).length) {
      _sliderMarks = defaultMarks
    } else {
      _sliderMarks = marks
    }
    const timeout = setTimeout(() => setSliderMarks(_sliderMarks), 0)
    return () => {
      clearTimeout(timeout)
    }
  }, [marks, defaultValue])

  if (!sliderMarks) return null
  return (
    <Row gutter={6}>
      <Col span={6}>{sliderTitle || title}</Col>
      <Col span={18}>
        <Slider
          range
          defaultValue={defaultValue}
          marks={sliderMarks}
          disabled
          min={0}
          max={duration}
        />
      </Col>
    </Row>
  )
}
